import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2ce00482"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce00482')) {
      api.createRecord('2ce00482', component.options)
    } else {
      api.reload('2ce00482', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2ce00482", function () {
      api.rerender('2ce00482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/function/Index.vue"
export default component.exports